import React, { useState, useCallback, useRef, useEffect } from "react";
import firebase from "../../../config/fbConfig";
import "./mainPanel.css";
import optionsPic from "./../../assets/options.png";
import closeBox from "./../../assets/remove.png";
import sendHourPic from "./../../assets/back.png";
import restaurantList from "../../restaurants/restaurantsList";
import restaurantListHe from "../../restaurants/restaurantsListHe";

const LiveDB = firebase.database();
const db = firebase.firestore();
let obj = {
	a: "rand",
	c: [
		{
			e: [
				{
					n: "Make it 0.5LTR",
					p: "0.5",
				},
			],
			n: "Carlsberg 330ml",
			p: "5.5",
			t: 6,
		},
		{
			e: [
				{
					n: "Grain",
					p: "2",
				},
				{
					n: "White",
					p: "2",
				},
			],
			n: "Greek Salad",
			o: ["Garlic Dill"],
			p: "11",
			t: 15,
		},
	],
	n: "loloool",
	p: 21,
	q: "052-535",
	r: 0,
	s: 2,
	t: 1587855778,
	x: "17:30",
	z: 0,
};
let temp1 = {
	"-M3ww6ZTfLOMt7I4Y4Y5": {
		a: "21 Fairey Street, Birmingham",
		c: [
			{
				e: [
					{
						n: "Make it 0.5LTR",
						p: "0.5",
					},
				],
				n: "Carlsberg 330ml",
				p: "5.5",
				t: 6,
			},
			{
				e: [
					{
						n: "Grain Bread",
						p: "2",
					},
					{
						n: "White Bread",
						p: "2",
					},
				],
				n: "Greek Salad",
				o: ["Garlic Dill"],
				p: "11",
				t: 15,
			},
		],
		n: "Michael Alonso",
		p: 21,
		q: "052-5345345",
		r: 0,
		s: 2,
		t: 1585865136,
		x: "17:30",
		z: 3,
	},
	"-M4-DFQuJSiM98Bluhc8": {
		c: [
			{
				n: "Chicken Breast Salad",
				o: ["Citrus Vinaigrette", "Garlic Dill"],
				p: "12",
				t: 12,
			},
			{
				n: "Coca Cola / Diet Coca Cola / Coca Cola Zero",
				o: ["Coca Cola"],
				p: "3",
				t: 3,
			},
		],
		n: "Neli Milo",
		p: 15,
		q: "052-5345345",
		r: 0,
		s: 1,
		t: 1585920325,
		x: "13:00",
		z: "1",
	},
	"-M4V1Xu_py0uak84tj3e": {
		c: [
			{
				n: "Bean Soup With Meat",
				p: "9",
				t: 9,
			},
			{
				e: [
					{
						n: "Additional Lachuch",
						p: "1.5",
					},
				],
				n: "Bean Soup With Leg",
				o: ["Lemon", "Fenugreek"],
				p: "9",
				t: 10.5,
			},
		],
		n: "Moris Johnson",
		p: 19.5,
		q: "052-5345345",
		r: 1,
		s: 1,
		t: 1586454189,
		x: "21:15",
		z: 0,
	},
	"-M4V37ougFOCTyv6UFqL": {
		c: [
			{
				n: "Bean Soup With Leg",
				o: ["Fenugreek"],
				p: "9",
				t: 9,
			},
			{
				n: "Flavored Neviot",
				o: ["Grapes"],
				p: "3",
				t: 3,
			},
		],
		n: "Moshe Abramovich",
		p: 12,
		q: "055-5341656",
		r: 2,
		s: 1,
		t: 1586454602,
		x: "21:45",
		z: 0,
	},
	"-M4V6LkNTLygp65g6vc4": {
		a: "3086 Buckhannan Avenue, Liverpool",
		c: [
			{
				e: [
					{
						n: "Grain Bread",
						p: "2",
					},
				],
				n: "Chicken Breast Salad",
				o: ["Garlic Dill", "Thousand Island Dressing"],
				p: "12",
				t: 14,
			},
			{
				n: "Fuze Tea Peach",
				p: "3",
				t: 3,
			},
		],
		n: "Kerri Heath",
		p: 17,
		q: "052-3277867",
		r: 3,
		s: 2,
		t: 1586455445,
		x: "22:00",
		z: 0,
	},
	"-M5Yk4vUaz3FBm_wtxXl": {
		c: [
			{
				e: [
					{
						n: "תוספת קצפת",
						p: "1",
					},
				],
				n: "מילקשייק בטעמים",
				o: ["וניל עוגיות", "ריבת חלב"],
				p: "6.5",
				t: 7.5,
			},
			{
				n: "קפה קר",
				p: "3.5",
				t: 3.5,
			},
		],
		i: "4HD465713T1972805",
		n: "בדיקה לא ידוע אם זה עובד",
		p: 11,
		q: "053-4364231",
		r: 3,
		s: 1,
		t: 1587590091,
		x: "01:30",
		z: 0,
	},
	"-M5c2Q0BFAVZKlKsGsVd": {
		c: [
			{
				n: "Iced Kinder",
				p: "4.5",
				t: 4.5,
			},
		],
		i: "71E49690P9806882R",
		n: "oki",
		p: 4.5,
		q: "054-3543121",
		r: 0,
		s: 2,
		t: 1587662336,
		x: "21:00",
		z: 0,
	},
};
function MainPanel({ DeOptimizeObject, getNameService, getNameState, getStyleState, getDateFormat }) {
	let [orders, setOrders] = useState([]); // This will store the filtered order according to the user's request (on top)
	const allOrders = useRef(); // This will store the
	const lastElemManageOrder = useRef(null); // This will be used to avoid few Manage Order elements opened at once
	const [, updateState] = React.useState(); // To force render
	const forceUpdate = useCallback(() => updateState({}), []); // Force render
	const selectRest = useRef(); // This will be used to store the selected restaurant value
	const searchArchive = useRef();
	let [search, setSearch] = useState([]);
	const allSearches = useRef([]);

	let mimicArchive = async () => {
		//////// SET INSTEAD OF TIMENOW the time u want to start removing from , for now everything since yesterday-past

		var snap;
		const getMaxFields = new Promise((resolve, reject) => {
			LiveDB.ref("orders/")
				.orderByChild("t")
				.once("value", (snapshot) => {
					snap = snapshot.val();

					let timeNow = firebase.firestore.Timestamp.fromDate(new Date()).seconds;
					let offset = timeNow - 86400; // 86400 means 1 day in miliseconds

					// Used to get the max numbers of fields in the array, that happened before the Offset = yesterday and storing them in variable i
					for (var i = 0; i < Object.keys(snap).length; i++) {
						if (snap[Object.keys(snap)[i]].t > offset) {
							break;
						}
					}
					resolve(i);
				});
		});
		const max = await getMaxFields;
		const snapshot = await db.collection("archive").doc("orders").get();
		let archive = snapshot.data().orders;

		// iterating all the fields that passed from yesterday, and relatively dividing them, if a phone number found in the archive list, add to this specific index, otherwise push a new phone
		for (let z = 0; z < max; z++) {
			let index = archive.findIndex((o) => o.q === snap[Object.keys(snap)[z]].q);
			if (index === -1) {
				archive.push({
					q: snap[Object.keys(snap)[z]].q,
					order: [snap[Object.keys(snap)[z]]],
				});
			} else {
				archive[index].order.push(snap[Object.keys(snap)[z]]);
			}
		}
		await db.collection("archive").doc("orders").set({ orders: archive }); // setting the new divided archive in the archive document

		for (let z = 0; z < max; z++) {
			LiveDB.ref("/archive").child(Object.keys(snap)[z]).remove();
		}
	};

	useEffect(() => {
		// mimicArchive();

		// THE NEXT FUNCTION is used to create a new copy of orders from LIVEDB into value called archive
		// for (let i = 0; i < Object.keys(temp1).length; i++) {
		//     LiveDB.ref('/archive').child(Object.keys(temp1)[i]).set(temp1[Object.keys(temp1)[i]]);
		// }

		let arr = [];
		// To actively listen to all the orders existing, getting list of orders ordered by time (ascending)
		LiveDB.ref("orders/")
			.orderByChild("t")
			.once("value", function (snapshot) {
				snapshot.forEach(function (child) {
					let requested = child.val();
					requested.key = child.key;
					arr.push(requested);
				});

				// Reveresing the array (to get descending time) and removing optimizations
				let newArr = [];
				for (let i = arr.length - 1; i >= 0; i--) {
					newArr.push(DeOptimizeObject(arr[i]));
				}

				orders = newArr;
				allOrders.current = orders;
				setOrders(orders);

				// Any new child added
				let timeNow = firebase.firestore.Timestamp.fromDate(new Date()).seconds;
				LiveDB.ref("orders/")
					.orderByChild("t")
					.startAt(timeNow)
					.on("child_added", function (child) {
						let requested = child.val();
						requested.key = child.key;
						let newArr = [DeOptimizeObject(requested)];
						orders = newArr.concat(orders); // Adding the new added child before the whole orders array
						// To store the new information in all orders
						allOrders.current = orders;

						if (selectRest.current != null) {
							// To order the array according to the restaurants pick on top
							if (selectRest.current.selectedIndex != 0) orders = allOrders.current.filter((order) => order.restaurant === selectRest.current.selectedIndex - 1);
						}

						setOrders(orders);
					});

				// If a child was changed, so change it accordingly
				LiveDB.ref("orders/").on("child_changed", function (child) {
					let requested = child.val();
					requested.key = child.key;
					let newArr = DeOptimizeObject(requested);
					let index = allOrders.current.findIndex((o) => o.key === newArr.key);
					allOrders.current[index] = newArr;
					orders = allOrders.current;
					if (selectRest.current != null) {
						// To order the array according to the restaurants pick on top
						if (selectRest.current.selectedIndex != 0) orders = allOrders.current.filter((order) => order.restaurant === selectRest.current.selectedIndex - 1);
					}
					setOrders(orders);
					forceUpdate();
				});

				// If a child was removed, so remove it from the array
				LiveDB.ref("orders/").on("child_removed", function (child) {
					let index = allOrders.current.findIndex((o) => o.key === child.key);
					if (index === -1) return;
					allOrders.current.splice(index, 1);
					orders = allOrders.current;
					if (selectRest.current != null) {
						// To order the array according to the restaurants pick on top
						if (selectRest.current.selectedIndex != 0) orders = allOrders.current.filter((order) => order.restaurant === selectRest.current.selectedIndex - 1);
					}
					setOrders(orders);
					forceUpdate();
				});
				/*
                setTimeout(() => {
                    let updates = {};
                    updates['/orders/' + '-M4-DFQuJSiM98Bluh48'] = obj;
                    LiveDB.ref().update(updates);
                }, 7000);
                */
			});

		return () => {
			LiveDB.ref("orders/").orderByChild("t").off("child_added");
			LiveDB.ref("orders/").off("child_added");
			LiveDB.ref("orders/").off("child_changed");
			LiveDB.ref("orders/").off("child_removed");
		};
	}, []);
	// Used when the user wants to get more information about the order, by clicking on the live retrieving the list of products/extras
	let showMoreInfo = (e) => {
		if (e.target.tagName === "TD") {
			e.target.parentNode.nextSibling.hidden = !e.target.parentNode.nextSibling.hidden;
			return;
		}
		if (e.target.tagName === "TR") {
			e.target.nextSibling.hidden = !e.target.nextSibling.hidden;
			return;
		}
		if (e.target.tagName === "TBODY") {
			e.target.firstChild.nextSibling.hidden = !e.target.firstChild.nextSibling.hidden;
			return;
		}
	};
	// As related to this function above ^ , retrieving this products/extras/fullname/address info here
	let getCartInfo = (cart, fullName, address) => {
		let extrasString = "";
		let nameOptions = "";
		cart.forEach((product) => {
			let addedString = "";
			if (product.options != null) addedString = "(" + product.options.join(", ") + "), ";
			else {
				addedString = ", ";
			}
			nameOptions += product.name + addedString;
			if (product.extras != null) {
				product.extras.forEach((extra) => {
					extrasString += extra.name + " ";
				});
				if (window.location.href.includes("/en")) {
					extrasString += `(for ${product.name}), `;
				} else {
					extrasString += `(ב${product.name}), `;
				}
			}
		});
		nameOptions = nameOptions.substring(0, nameOptions.length - 2);

		if (window.location.href.includes("/en")) {
			// If it is panel in English
			if (extrasString !== "") extrasString = `<div><b style="padding-right: 10px">Extras:</b> ` + extrasString.substring(0, extrasString.length - 2) + ".</div>";

			if (address !== undefined) {
				return `<div style="padding-bottom: 10px"><b style="padding-right: 10px">Full Name:</b> ${fullName}.</div>
                <div style="padding-bottom: 10px"><b style="padding-right: 10px">Address:</b> ${address}.</div>
                <div style="padding-bottom: 10px"><b style="padding-right: 10px">Products:</b> ${nameOptions}.</div> ${extrasString}`;
			} else {
				return `<div style="padding-bottom: 10px"><b style="padding-right: 10px">Full Name:</b> ${fullName}.</div>
                <div style="padding-bottom: 10px"><b style="padding-right: 10px">Products:</b> ${nameOptions}.</div> ${extrasString}`;
			}
		} else {
			// If it is panel in Hebrew
			if (extrasString !== "") extrasString = `<div><b style="padding-right: 10px">תוספות:</b> ` + extrasString.substring(0, extrasString.length - 2) + ".</div>";

			if (address !== undefined) {
				return `<div style="padding-bottom: 10px"><b style="padding-right: 10px">שם מלא:</b> ${fullName}.</div>
                <div style="padding-bottom: 10px"><b style="padding-right: 10px">כתובת מגורים:</b> ${address}.</div>
                <div style="padding-bottom: 10px"><b style="padding-right: 10px">מנות שהוזמנו:</b> ${nameOptions}.</div> ${extrasString}`;
			} else {
				return `<div style="padding-bottom: 10px"><b style="padding-right: 10px">שם מלא:</b> ${fullName}.</div>
                <div style="padding-bottom: 10px"><b style="padding-right: 10px">מנות שהוזמנו:</b> ${nameOptions}.</div> ${extrasString}`;
			}
		}
	};

	// Used when the user clicks on Settings image to open manage order
	let openManageOrder = (e) => {
		document.getElementById("darkness").style.display = "block";
		if (lastElemManageOrder.current !== null) {
			lastElemManageOrder.current.hidden = true; // Closing the previous more info box in order to avoid a case of many manageOrder boxes opened
		}
		e.target.parentNode.parentNode.nextSibling.hidden = false;
		lastElemManageOrder.current = e.target.parentNode.parentNode.nextSibling;
	};
	// Used when the user wants to close the manage order element
	let closeManageOrder = (e) => {
		document.getElementById("darkness").style.display = "none"; // Hiding the darkness
		e.target.parentNode.parentNode.parentNode.hidden = true; // Hiding the Manage Order Box Element
		e.target.parentNode.parentNode.parentNode.previousSibling.hidden = true; // Hiding the showMoreInfo line (products/extras)
		e.target.nextSibling.lastChild.style.display = "none"; // Hiding the span of Input & button to send hour in accept with delay
	};

	// Used when the user clicks on an option in manage order element such as cancel/accept/accept with delay order
	let OrderStateExecute = (e, state, key, trackID, totalPrice) => {
		if (e.target.tagName !== "IMG") {
			if (state == 3) {
				e.target.nextSibling.style.display = "block";
				return;
			}
		}

		if (state == 1) {
			if (window.location.href.includes("/en")) {
				if (!window.confirm("Are you sure you want to 𝗖𝗔𝗡𝗖𝗘𝗟 the order?")) return;
			} else {
				if (!window.confirm("האם אתה בטוח שברצונך *לבטל* את ההזמנה?")) return;
			}

			// If it was chosen to cancel, make a refund in 5 minutes
			setTimeout(() => {
				const getRefund = firebase.functions().httpsCallable("getRefund");

				getRefund({ id: trackID, money: totalPrice })
					.then((res) => {
						// If the refund was completed, so move to homepage and remove it from the database
						if (res.data.status === "COMPLETED" || res.data.status === "CREATED") {
							LiveDB.ref()
								.child("orders/" + key)
								.set(null);
						}
					})
					.catch((err) => {
						alert(`There was an error, ${err}`);
					});
			}, 300000);
		}

		if (state == 2) {
			if (window.location.href.includes("/en")) {
				if (!window.confirm("Are you sure you want to 𝗔𝗖𝗖𝗘𝗣𝗧 the order?")) return;
			} else {
				if (!window.confirm("האם אתה בטוח שברצונך *לקבל* את ההזמנה?")) return;
			}
		}

		// If it isn't accept with specific time, just change the state for the user
		if (state != 3) {
			let obj = {
				z: state,
			};
			LiveDB.ref("orders/" + key).update(obj);

			if (window.location.href.includes("/en")) {
				alert("Successfully changed");
			} else {
				alert("עודכן בהצלחה");
			}

			e.target.parentNode.parentNode.parentNode.parentNode.hidden = true; // Hiding the tr
		}

		if (state == 3 && e.target.tagName == "IMG") {
			if (window.location.href.includes("/en")) {
				if (!window.confirm("Are you sure you want to 𝗔𝗖𝗖𝗘𝗣𝗧 the order with 𝗱𝗲𝗹𝗮𝘆?")) return;
			} else {
				if (!window.confirm("האם אתה בטוח שברצונך *לקבל* את ההזמנה בשעה ספציפית?")) return;
			}

			let obj = {
				x: e.target.previousSibling.value,
				z: state,
			};
			LiveDB.ref("orders/" + key).update(obj);

			if (window.location.href.includes("/en")) {
				alert("Successfully changed");
			} else {
				alert("עודכן בהצלחה");
			}

			e.target.parentNode.parentNode.parentNode.parentNode.parentNode.hidden = true; // Hiding the tr
		}

		document.getElementById("darkness").style.display = "none"; // Hiding the darkness
	};
	let addHyphenHour = (e) => {
		let targ = e.target;
		let key = e.key;
		let event = e;
		if ((key >= "0" && key <= "9") || key == "Backspace") {
			setTimeout(() => {
				if (targ.value.length === 2 && key != "Backspace") {
					targ.value = targ.value + ":";
				}
				if (key == "Backspace" && targ.value.length === 2) {
					targ.value = targ.value.substring(0, 1);
				}
			});

			if (targ.value.length > 4) {
				if (key !== "Backspace") {
					event.preventDefault();
				}
			}
		} else {
			event.preventDefault();
		}
	};

	// To order the array according to the restaurants pick on top
	let filterOrder = (index) => {
		if (index == 0) {
			setOrders(allOrders.current);
			setSearch(allSearches.current);
		}
		if (index != 0) {
			orders = allOrders.current.filter((order) => order.restaurant === index - 1);
			setOrders(orders);

			// To avoid an error on the first time
			if (allSearches.current.length !== 0) {
				search = allSearches.current.filter((order) => order.restaurant === index - 1);
				setSearch(search);
			}
		}
	};
	// To force the user to enter only numbers
	let addHyphenSearchPhone = (e) => {
		if (e.key === "Enter") initiateSearch(e.target.value);
		let targ = e.target;
		let key = e.key;
		let event = e;
		if ((key >= "0" && key <= "9") || key === "Backspace" || key === "Ctrl" || key === "v") {
			setTimeout(() => {
				if (targ.value[targ.value.length - 1] === "v") targ.value = targ.value.substring(0, targ.value.length - 1);
				if (targ.value.length === 3 && key != "Backspace") {
					targ.value = targ.value + "-";
				}
				if (key == "Backspace" && targ.value.length === 3) {
					targ.value = targ.value.substring(0, 2);
				}
			});

			if (targ.value.length > 10) {
				if (key !== "Backspace") {
					event.preventDefault();
				}
			}
		} else {
			event.preventDefault();
		}
	};

	let initiateSearch = (value) => {
		let searchArr = [];
		if (value.length !== 11) {
			setSearch(searchArr);
			allSearches.current = searchArr;
			return;
		}
		LiveDB.ref("orders/")
			.orderByChild("q")
			.equalTo(value)
			.once("value", function (snapshot) {
				snapshot.forEach(function (child) {
					let requested = child.val();
					requested.key = child.key;
					searchArr.push(requested);
				});

				// Reveresing the array and removing optimizations
				let newArr = [];
				for (let i = searchArr.length - 1; i >= 0; i--) {
					newArr.push(DeOptimizeObject(searchArr[i]));
				}
				search = newArr;
				allSearches.current = search; // to store all searches
				// To filter
				if (selectRest.current.selectedIndex != 0) search = allSearches.current.filter((order) => order.restaurant === selectRest.current.selectedIndex - 1);

				setSearch(search);
			});
	};

	// If it is a English page, so render it in English
	if (window.location.href.includes("/en")) {
		return (
			<div id="mainPanel">
				<div className="titleComponent">Main Panel</div>
				<div id="tableWrapper">
					<table id="table" align="center">
						<thead>
							<tr>
								<th></th>
								<th>Received Time</th>
								<th>Restaurant</th>
								<th>State</th>
								<th>Chosen Time</th>
								<th>Service</th>
								<th>Phone Number</th>
								<th>Total Price</th>
							</tr>
						</thead>
						<tbody>
							{orders.length === 0 ? (
								<tr>
									<td colSpan="8">Nothing was found 😢</td>
								</tr>
							) : (
								<React.Fragment>
									{orders.map((value, index) => (
										<React.Fragment key={value.key}>
											<tr onClick={showMoreInfo}>
												<td>({index + 1})</td>
												<td tablename="receivedTime" dangerouslySetInnerHTML={{ __html: getDateFormat(value.timestamp) }}></td>
												<td tablename="restaurantName">{restaurantList[value.restaurant].title}</td>
												<td tablename="state" style={getStyleState(value.state)}>
													{getNameState(value.state)}
												</td>
												<td tablename="chosenTime">{value.chosenTime}</td>
												<td tablename="service">{getNameService(value.service)}</td>
												<td tablename="phone">{value.phoneNum}</td>
												<td tablename="price">{value.totalPrice}</td>
											</tr>
											<tr className="infoAdded" hidden>
												<td></td>
												<td colSpan="6" className="productsExtrasInfo" dangerouslySetInnerHTML={{ __html: getCartInfo(value.cart, value.fullName, value.address) }}></td>
												<td className="moreInfoButton"> {value.state == 0 && <img src={optionsPic} onClick={openManageOrder} />} </td>
											</tr>
											<tr hidden>
												<td className="hideLineManageOrder" colSpan="8">
													<div className="manageOrder">
														<img src={closeBox} onClick={closeManageOrder} />
														<div className="manageWrapper">
															<span style={{ display: "block", textAlign: "center", paddingBottom: "15px", fontWeight: "bold", width: "85%", margin: "0 auto 10px auto" }}>
																{value.fullName}'s Order (€{value.totalPrice})
															</span>
															<div data-state="1" onClick={(e) => OrderStateExecute(window.event, e.target.dataset.state, value.key, value.id, value.totalPrice)}>
																Cancel Order <br /> Costumer will get a refund{" "}
															</div>
															<hr />
															<div data-state="2" onClick={(e) => OrderStateExecute(window.event, e.target.dataset.state, value.key)}>
																Accept Order
															</div>
															<hr />
															<div data-state="3" onClick={(e) => OrderStateExecute(window.event, e.target.dataset.state, value.key)}>
																Accept Order With Specific Time
															</div>
															<span style={{ display: "none" }}>
																<input type="text" onKeyDown={addHyphenHour} />
																<img src={sendHourPic} onClick={() => OrderStateExecute(window.event, 3, value.key)} />
															</span>
														</div>
													</div>
												</td>
											</tr>
										</React.Fragment>
									))}
								</React.Fragment>
							)}
						</tbody>
					</table>
				</div>

				<div id="archiveWrapper" style={{ display: "none" }}>
					<div id="searchWrapper">
						<label htmlFor="searchArchive"> Search by phone number:</label>
						<input type="text" id="searchArchive" ref={searchArchive} onKeyDown={addHyphenSearchPhone} />
						<button id="searchPhone" onClick={() => initiateSearch(searchArchive.current.value)}>
							SEARCH
						</button>
					</div>

					<table id="table" align="center" className="searchTable">
						<thead>
							<tr>
								<th></th>
								<th>Received Time</th>
								<th>Restaurant</th>
								<th>State</th>
								<th>Chosen Time</th>
								<th>Service</th>
								<th>Phone Number</th>
								<th>Total Price</th>
							</tr>
						</thead>
						<tbody>
							{search.length === 0 ? (
								<tr>
									<td colSpan="8">Nothing was found 😢</td>
								</tr>
							) : (
								<React.Fragment>
									{search.map((value, index) => (
										<React.Fragment key={value.key}>
											<tr onClick={showMoreInfo}>
												<td>({index + 1})</td>
												<td tablename="receivedTime" dangerouslySetInnerHTML={{ __html: getDateFormat(value.timestamp) }}></td>
												<td tablename="restaurantName">{restaurantList[value.restaurant].title}</td>
												<td tablename="state" style={getStyleState(value.state)}>
													{getNameState(value.state)}
												</td>
												<td tablename="chosenTime">{value.chosenTime}</td>
												<td tablename="service">{getNameService(value.service)}</td>
												<td tablename="phone">{value.phoneNum}</td>
												<td tablename="price">{value.totalPrice}</td>
											</tr>
											<tr className="infoAdded" hidden>
												<td></td>
												<td colSpan="6" className="productsExtrasInfo" dangerouslySetInnerHTML={{ __html: getCartInfo(value.cart, value.fullName, value.address) }}></td>
												<td></td>
											</tr>
										</React.Fragment>
									))}
								</React.Fragment>
							)}
						</tbody>
					</table>
				</div>

				<select defaultValue={"all"} className="pickRest" ref={selectRest} onChange={() => filterOrder(selectRest.current.selectedIndex)}>
					<option value="all">-- ALL --</option>
					{restaurantList.map((val, index) => (
						<option value={val.title} key={index}>
							{val.title}
						</option>
					))}
				</select>

				<div id="darkness" style={{ display: "none" }}></div>
			</div>
		);
	}

	// Else render it in Hebrew
	return (
		<div id="mainPanel">
			<div className="titleComponent">פאנל ראשי</div>
			<div id="tableWrapper">
				<table id="table" align="center">
					<thead>
						<tr>
							<th></th>
							<th>זמן קבלה</th>
							<th>שם המסעדה</th>
							<th>מצב ההזמנה</th>
							<th>זמן נבחר</th>
							<th>שירות מבוקש</th>
							<th>מספר פלאפון</th>
							<th>מחיר כולל</th>
						</tr>
					</thead>
					<tbody>
						{orders.length === 0 ? (
							<tr>
								<td colSpan="8">לא נמצאו תוצאות 😢</td>
							</tr>
						) : (
							<React.Fragment>
								{orders.map((value, index) => (
									<React.Fragment key={value.key}>
										<tr onClick={showMoreInfo}>
											<td>({index + 1})</td>
											<td tablename="receivedTime" dangerouslySetInnerHTML={{ __html: getDateFormat(value.timestamp) }}></td>
											<td tablename="restaurantName">{restaurantListHe[value.restaurant].title}</td>
											<td tablename="state" style={getStyleState(value.state)}>
												{getNameState(value.state)}
											</td>
											<td tablename="chosenTime">{value.chosenTime}</td>
											<td tablename="service">{getNameService(value.service)}</td>
											<td tablename="phone">{value.phoneNum}</td>
											<td tablename="price">{value.totalPrice}</td>
										</tr>
										<tr className="infoAdded" hidden>
											<td></td>
											<td colSpan="6" className="productsExtrasInfo" dangerouslySetInnerHTML={{ __html: getCartInfo(value.cart, value.fullName, value.address) }}></td>
											<td className="moreInfoButton"> {value.state == 0 && <img src={optionsPic} onClick={openManageOrder} />} </td>
										</tr>
										<tr hidden>
											<td className="hideLineManageOrder" colSpan="8">
												<div className="manageOrder">
													<img src={closeBox} onClick={closeManageOrder} />
													<div className="manageWrapper">
														<span style={{ display: "block", textAlign: "center", paddingBottom: "15px", fontWeight: "bold", width: "85%", margin: "0 auto 10px auto" }}>
															ההזמנה של {value.fullName} (€{value.totalPrice})
														</span>
														<div data-state="1" onClick={(e) => OrderStateExecute(window.event, e.target.dataset.state, value.key, value.id, value.totalPrice)}>
															ביטול ההזמנה <br /> הלקוח יקבל החזר כספי{" "}
														</div>
														<hr />
														<div data-state="2" onClick={(e) => OrderStateExecute(window.event, e.target.dataset.state, value.key)}>
															קבל את ההזמנה
														</div>
														<hr />
														<div data-state="3" onClick={(e) => OrderStateExecute(window.event, e.target.dataset.state, value.key)}>
															קבל את ההזמנה בשעה ספציפית
														</div>
														<span style={{ display: "none" }}>
															<input type="text" onKeyDown={addHyphenHour} />
															<img src={sendHourPic} onClick={() => OrderStateExecute(window.event, 3, value.key)} style={{ transform: "none" }} />
														</span>
													</div>
												</div>
											</td>
										</tr>
									</React.Fragment>
								))}
							</React.Fragment>
						)}
					</tbody>
				</table>
			</div>

			<div id="archiveWrapper" style={{ display: "none" }}>
				<div id="searchWrapper">
					<label htmlFor="searchArchive"> חיפוש ע"פ מספר פלאפון:</label>
					<input type="text" id="searchArchive" ref={searchArchive} onKeyDown={addHyphenSearchPhone} />
					<button id="searchPhone" onClick={() => initiateSearch(searchArchive.current.value)}>
						חיפוש
					</button>
				</div>

				<table id="table" align="center" className="searchTable">
					<thead>
						<tr>
							<th></th>
							<th>זמן קבלה</th>
							<th>שם המסעדה</th>
							<th>מצב ההזמנה</th>
							<th>זמן נבחר</th>
							<th>שירות מבוקש</th>
							<th>מספר פלאפון</th>
							<th>מחיר כולל</th>
						</tr>
					</thead>
					<tbody>
						{search.length === 0 ? (
							<tr>
								<td colSpan="8">לא נמצאו תוצאות 😢</td>
							</tr>
						) : (
							<React.Fragment>
								{search.map((value, index) => (
									<React.Fragment key={value.key}>
										<tr onClick={showMoreInfo}>
											<td>({index + 1})</td>
											<td tablename="receivedTime" dangerouslySetInnerHTML={{ __html: getDateFormat(value.timestamp) }}></td>
											<td tablename="restaurantName">{restaurantList[value.restaurant].title}</td>
											<td tablename="state" style={getStyleState(value.state)}>
												{getNameState(value.state)}
											</td>
											<td tablename="chosenTime">{value.chosenTime}</td>
											<td tablename="service">{getNameService(value.service)}</td>
											<td tablename="phone">{value.phoneNum}</td>
											<td tablename="price">{value.totalPrice}</td>
										</tr>
										<tr className="infoAdded" hidden>
											<td></td>
											<td colSpan="6" className="productsExtrasInfo" dangerouslySetInnerHTML={{ __html: getCartInfo(value.cart, value.fullName, value.address) }}></td>
											<td></td>
										</tr>
									</React.Fragment>
								))}
							</React.Fragment>
						)}
					</tbody>
				</table>
			</div>

			<select defaultValue={"all"} className="pickRest" ref={selectRest} onChange={() => filterOrder(selectRest.current.selectedIndex)}>
				<option value="all">-- מסעדה --</option>
				{restaurantListHe.map((val, index) => (
					<option value={val.title} key={index}>
						{val.title}
					</option>
				))}
			</select>

			<div id="darkness" style={{ display: "none" }}></div>
		</div>
	);
}

export default MainPanel;
